import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';

import {loadModelAsync} from '../../../features/election/store/actions';
import ISystemInfo = MyTypes.ISystemInfo;
import {getElectionInfo} from '../../../features/election/store/selectors';
import {getSystemInfo, getSystemLoaded} from '../../../store/system/selectors';

const SplashScreen: React.FC = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const loaded = useSelector(getSystemLoaded);
  const sysInfo = useSelector(getSystemInfo);
  const electionInfo = useSelector(getElectionInfo);
  const elRoot = document.getElementById('root');
  const elSplash = document.getElementById('root-splash');
  const elError = document.getElementById('root-error');

  useEffect(() => {
    dispatch(loadModelAsync.request());
  }, []);

  useEffect(() => {
    if (
      sysInfo.code === 'ELECTION_NOT_FOUND' ||
      sysInfo.code === 'ELECTION_CLOSED'
    ) {
      showError(sysInfo);
    } else if (loaded && !electionInfo.loading) {
      showApp();
    } else {
      showSplashScreen();
    }

    // showApp();
  }, [loaded, sysInfo, electionInfo]);

  const showSplashScreen = () => {
    if (elSplash && elRoot && elError) {
      elSplash.style.display = 'flex';
      elRoot.style.display = 'none';
      elError.style.display = 'none';
    }
  };

  const showApp = () => {
    if (elSplash && elRoot && elError) {
      elSplash.style.display = 'none';
      elRoot.style.display = 'flex';
      elError.style.display = 'none';
    }
  };

  const showError = (info: ISystemInfo) => {
    if (elSplash && elRoot) {
      elSplash.style.display = 'none';
      elRoot.style.display = 'none';
    }

    if (!elError) {
      return;
    }

    elError.style.display = 'flex';

    const elH3 = elError.querySelector('h3');
    const elP = elError.querySelector('p');

    if (elH3) {
      if (info.code === 'ELECTION_NOT_FOUND') {
        elH3.textContent = t('eleicao-nao-encontrada');
      } else if (info.code === 'ELECTION_CLOSED') {
        elH3.textContent = t('erros.erro-encerrada');
      } else {
        elH3.textContent = info.code || '';
      }
    }
    if (elP) {
      elP.textContent = info.message || '';
    }
  };

  return <React.Fragment />;
};

export default SplashScreen;



// WEBPACK FOOTER //
// ./src/shared/components/splashscreen/SplashScreen.tsx